<template>
    <div>



        <div v-for="(snack, i) in snacks" :key="i">

            <v-snackbar
                    :value="true"
                    :timeout="snack.timeout"
            >

                <div class="d-flex">
                    <div class="pr-2 font-weight-bold" :class="snack.titleColor+'--text'">{{snack.title}}</div>
                    <div>{{snack.message}}</div>
                </div>

                <template v-slot:action="{}">



                    <v-btn
                            v-for="(btn, i) in snack.buttons"
                            :key="i"
                            :color="btn.color"
                            text
                            @click="btn.val ? btn.cb(btn.val) : btn.cb(snack.id)"
                    >
                        {{ btn.title }}
                    </v-btn>
                </template>
            </v-snackbar>

        </div>
    </div>
</template>

<script>
import {events} from "../../core/snack";

export default {
    props: {
        val: Boolean
    },
    data() {
        return {
            snacks: [],
            nextID: 0
        }
    },
    created() {
        events.on('showSnack', (snackConfig) => {this.addSnack(snackConfig)})
    },
    methods: {
        addSnack(config) {
            console.log('SNACK ADDED')
            let snack = {
                id: this.nextID,
                title: null,
                titleColor: null,
                message: config.message || '',
                timeout: config.timeout || 3000,
                position: config.position || 'bottom',
            }

            this.nextID = ++this.nextID

            if (!config.title) {
                snack.title = 'Info'
                snack.titleColor = 'primary'
            }

            if (typeof config.title === 'object') {
                snack.titleColor = config.title.color || 'primary'
                snack.title = config.title.value
            } else {
                snack.title = config.title || 'Info'
                snack.titleColor = 'primary'
            }

            let buttons = []

            if (Array.isArray(config.buttons) && config.buttons.length) {
                buttons = config.buttons.map((btn) => {
                    if (typeof btn === 'string') {
                        return  {title: btn, cb: this.removeSnack, color: 'secondary'}
                    } else {
                        return {
                            title: btn.title || 'Close',
                            cb: btn.cb || this.removeSnack,
                            color: btn.color || 'error',
                            val: btn.val || null
                        }
                    }
                })
            } else {
                buttons = [{title: 'Close', cb: this.removeSnack, color: 'error'}]
            }

            snack.buttons = buttons;

            this.snacks.push(snack)

            setTimeout(() => {
                this.removeSnack(snack.id)
            }, snack.timeout)
        },

        removeSnack(id) {
            this.snacks = this.snacks.filter(obj => obj.id !== id)
        }

    },
    computed: {
    },
}
</script>

<style scoped>

</style>